import request from "../request";

export const getMaintenanceLogsSkipAndLimit = (skip = 0, limit = 5, filter) => 
    request.post(`maintenance/skip/${skip}/limit/${limit}`, filter).then((res) => res);

export const getMaintenanceLogById = (id) =>
    request.get(`maintenance/${id}`).then((res) => res);

export const getModule = (module, data) =>
    request.post(`maintenance/${module}/list`, data).then((res) => res);

export const syncModule = (module, data) =>
    request.post(`maintenance/${module}`, data).then((res) => res);

export const syncDisabledModule =  (module, data) =>
    request.post(`maintenance/${module}/disable`, data).then((res) => res);